import {elementInViewport} from "@/utils/utils.js"

export default async () => {
  let throttleTimer;
  const throttleDelay = 100;

  async function initMaps() {
    const mainMapRoot = document.querySelector('#tf-map--wrapper');
    const stationRoot = document.querySelector('#station-app');
    if (mainMapRoot && elementInViewport(mainMapRoot)) {
      await window.appInitializer.initMainMapApp()
    }
    if (stationRoot && elementInViewport(stationRoot)) {
      await window.appInitializer.initStationDomainApp()
    }

    if (window.appInitializer.mainMapApp && window.appInitializer.stationDomainMap) {
      window.removeEventListener('scroll', throttledInitMaps)
    }
  }

  function throttledInitMaps() {
    clearTimeout(throttleTimer);
    throttleTimer = setTimeout(initMaps, throttleDelay);
  }

  window.addEventListener('scroll', throttledInitMaps)
  await initMaps()
}
